export const tokenAddresses = {
  EUL: "0x9ceeD3A7f753608372eeAb300486cc7c2F38AC68",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x2e3b32730B4F6b6502BdAa9122df3B026eDE5391",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
